import React, {useReducer, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations'
import {makeStyles} from "@material-ui/styles";
import GridBlock from "components/GridBlock";
import GetAppIcon from '@material-ui/icons/GetApp';
import WorkableButton from "components/button/WorkableButton";
import iconWorksReducer from "libs/iconWorksReducer";
import {useParams} from "react-router";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {OfferMode} from "../../../common/constants/OfferMode";
import Dropzone from "components/Dropzone";
import UploadService from "services/UploadService";
import Endpoints from "constants/Endpoints";
import Typography from "components/Typography";
import SingleButton from "components/popup/components/SingleButton";
import isResponseValid from "libs/isResponseValid";
import useSnackbar from "hooks/useSnackbar";
import {Table, TableBody, TableCell, TableContainer, TableRow} from "@material-ui/core";
import clsx from "clsx";
import BoldTypography from "../../../../../../../../../components/BoldTypography";
import RouterPath from "../../../../../../../../../libs/RouterPath";
import {StageSections} from "../../../../constants/StageSections";
import DemandOffersService from "../../../../../../../../../services/DemandOffersService";

const useStyle = makeStyles(theme => ({


    partColumn: {
        width: 70,
        padding: theme.spacing(0.5, 2, 0.5, 2),
        borderTop: "solid 2px #333",
        borderBottom: "none",
    },
    nameColumn: {
        width: "50%",
        padding: theme.spacing(0.5, 2, 0.5, 2),
        borderTop: "solid 2px #333"
    },
    errorColumn: {
        padding: theme.spacing(0.5, 2, 0.5, 2),
        borderTop: "solid 2px #333",
    },

    entryLpColumn: {
        borderBottom: "none"
    },
    entryColumn: {
        padding: theme.spacing(0.5, 2, 0.5, 2),
    },

    step: {
        marginTop: theme.spacing(2)
    },
    fontSize: {
        fontSize: "0.9rem",
    },
    bold: {
        fontWeight: "bold",
    },
    success: {color: theme.palette.common.success},
    error: {color: theme.palette.error.main},
}))

function ImportOfferFormPopup(
    {
        onClose,
    }) {
    const classes = useStyle();
    const params = useParams();
    const [result, setResult] = useState();
    const {enqueueErrorSnackbar, enqueueWarningSnackbar, enqueueSuccessSnackbar} = useSnackbar();
    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        download: false,
        upload: false
    });

    const downloadTemplate = () => {
        dispatchIconWorks({type: 'download', works: true})
        DemandOffersOfferService.getDownloadOfferTemplate(params.id, params.stageId, undefined, OfferMode.EDIT)
            .finally(() => dispatchIconWorks({type: 'download', works: false}))
    }

    const handleBrowserFileSelect = (selectedFiles) => {
        dispatchIconWorks({type: 'upload', works: true})
        setResult(null)
        UploadService.upload(selectedFiles[0], () => {
        }, Endpoints.DEMAND_OFFERS_OFFER_MODE_TEMPLATE(params.id, params.stageId, OfferMode.EDIT, undefined)).then(response => {
            if (isResponseValid(response, enqueueErrorSnackbar)) {
                const data = response.result;
                if (data.length > 0) {
                    if (data.some(x => !x.success)) {
                        setResult(data)
                    } else {
                        enqueueSuccessSnackbar(Tr("offer_form_import_export_success"));
                        DemandOffersService.getStageSection(params.id, params.stageId, StageSections.OFFER_EDIT)
                        onClose();
                        const href = RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID, {
                            id: params.id,
                            stageId: params.stageId
                        });
                        RouterPath.redirectWithoutHistory(href);
                    }
                } else {
                    enqueueWarningSnackbar(Tr("fill_at_least_one_position"));
                }
            }
        }).catch((e) => {
            console.error(e);
        }).finally(() => dispatchIconWorks({type: 'upload', works: false}))

    }

    return (
        <Dialog
            open
            title={Tr("offer_form_import_export")}
            maxWidth='lg'
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr("close")}
                onClick={onClose}
                disabled={iconWorks.anyWorks}
            />}
        >
            <GridBlock column>

                <Typography dangerouslySetInnerHTML={{__html: Tr("offer_form_import_export_step1")}}/>

                <WorkableButton Icon={GetAppIcon} onClick={downloadTemplate} working={iconWorks.download}
                                disabled={iconWorks.anyWorks}>{Tr("offer_form_download")}</WorkableButton>
                <Typography className={classes.step} dangerouslySetInnerHTML={{__html: Tr("offer_form_import_export_step2")}}/>
                <Typography className={classes.step} dangerouslySetInnerHTML={{__html: Tr("offer_form_import_export_step3")}}/>

                <Dropzone
                    className={classes.dropzone}
                    onChange={handleBrowserFileSelect}
                    multiple={false}
                    acceptExtensionList={['xlsx']}
                    working={iconWorks.upload}
                    disabled={iconWorks.anyWorks}
                />

                {
                    !!result && <TableContainer className={clsx(classes.step)}>
                        <BoldTypography align="center" variant="h6">{Tr("offer_form_import_export_summary")}</BoldTypography>
                        <Table>
                            <TableBody>
                                {
                                    result.map(pos => {
                                        const errors = [];
                                        if (!pos.success && pos.errors) {
                                            Object.keys(pos.errors).forEach(sectionName => {
                                                const section = pos.errors[sectionName];
                                                Object.keys(section).forEach((critName) => {
                                                    section[critName].forEach((err) => errors.push({
                                                        ...err,
                                                        name: critName
                                                    }))
                                                })
                                            })
                                        }
                                        return (<>
                                            <TableRow>
                                                <TableCell className={clsx(classes.partColumn, classes.bold)}>{Tr("part_x", {x: pos.ordinalNumber})}</TableCell>
                                                <TableCell className={classes.nameColumn}>{pos.positionName}</TableCell>
                                                <TableCell
                                                    className={clsx(classes.errorColumn, classes.bold, pos.success ? classes.success : classes.error)}>{pos.status}</TableCell>
                                            </TableRow>
                                            {
                                                errors.length > 0 && errors.map(error => (<TableRow>
                                                    <TableCell className={clsx(classes.entryLpColumn, classes.bold)}></TableCell>
                                                    <TableCell className={classes.entryColumn}>
                                                        {Tr("excel_cell")}: <span className={classes.bold}>{error.cellAddress}</span> - {error.name}
                                                    </TableCell>
                                                    <TableCell className={clsx(classes.entryColumn, classes.bold, pos.success ? classes.success : classes.error)}>
                                                        {error.error}
                                                    </TableCell>
                                                </TableRow>))
                                            }
                                        </>)
                                    })


                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }

            </GridBlock>

        </Dialog>
    )
}

ImportOfferFormPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default ImportOfferFormPopup;
